import { type TLocation } from '@/microfrontends/filters/shared/types/location';

export const LOCATION_DEFAULT: TLocation = {
  name: 'Москва',
  hasDistricts: true,
  hasNeighbors: false,
  parentId: null,
  id: 1,
  lat: 55.7557,
  boundedBy: {
    upperCorner: {
      lat: 56.021224,
      lng: 37.967428,
    },
    lowerCorner: {
      lat: 55.142175,
      lng: 36.803101,
    },
  },
  hasHighway: false,
  mainTownId: null,
  fullName: 'Москва',
  hasMetro: true,
  lng: 37.6213,
  displayName: 'Москва',
  hasRegionalDistricts: true,
};
